// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-main-page-js": () => import("./../../../src/pages/main-page.js" /* webpackChunkName: "component---src-pages-main-page-js" */),
  "component---src-pages-menu-js": () => import("./../../../src/pages/menu.js" /* webpackChunkName: "component---src-pages-menu-js" */),
  "component---src-pages-mobile-page-js": () => import("./../../../src/pages/mobile-page.js" /* webpackChunkName: "component---src-pages-mobile-page-js" */)
}

